import IsSigningComponent from './is-signing-component'
import HasSignedComponent from './has-signed-component'
import SigningCompleteComponent from './signing-complete-component'

const SigningProgressBar = ({
  progressStart,
  itemsLength,
  signingFinished,
  handleSubmit,
  handleNextField,
  hasSigned,
  isPackageFileSigned,
  contractId,
  currentDocumentId,
  currentSigner
}) => {
  if (isPackageFileSigned)
    return (
      <SigningCompleteComponent contractId={contractId} currentDocumentId={currentDocumentId} />
    )
  if (hasSigned) return <HasSignedComponent currentSigner={currentSigner} />
  return (
    <IsSigningComponent
      progressStart={progressStart}
      itemsLength={itemsLength}
      signingFinished={signingFinished}
      handleSubmit={handleSubmit}
      handleNextField={handleNextField}
    />
  )
}

export default SigningProgressBar
